import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'

import longTermLeaseInvoiceRequests from '../LongTermLeaseInvoice.requests'

const useGetLongTermLeaseInvoice = ({
    longTermLeaseInvoiceId,
}: {
    longTermLeaseInvoiceId: number,
}) => {
    return useRequest({
        key: RequestKeys.getLongTermLeaseInvoice,
        params: {
            longTermLeaseInvoiceId,
        },
        requestFunc: RequestFn.getEntity(longTermLeaseInvoiceRequests.getLongTermLeaseInvoice),
        enabled: Boolean(longTermLeaseInvoiceId),
    })
}

export default useGetLongTermLeaseInvoice
